import { useCallback } from 'react';
import { useContentBlockFieldParser } from './useContentBlockFieldParser';
import { isContentBackgroundColor } from '../utils';
import { ContentBackgroundColor, CustomContent, FieldOptionsWithFallback } from '../types';

export const useContentBlockBackgroundColor = (
  customContent: CustomContent[],
  { slug, fallback }: FieldOptionsWithFallback<ContentBackgroundColor>
) => {
  const parser = useCallback(
    (i: string) => (isContentBackgroundColor(i) ? i : fallback),
    [fallback]
  );
  return useContentBlockFieldParser(customContent, 'bg-color', {
    slug,
    parser
  });
};
